import { render } from "./ListeAssurance.vue?vue&type=template&id=5a9785fe&scoped=true"
import script from "./ListeAssurance.vue?vue&type=script&lang=js"
export * from "./ListeAssurance.vue?vue&type=script&lang=js"

import "./ListeAssurance.vue?vue&type=style&index=0&id=5a9785fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9785fe"]])

export default __exports__